import React from 'react';

import PrivateRoutes from 'routes/PrivateRoutes';

import NotFound from 'components/NotFound';
import AuditLogs from 'components/audit/logs/AuditLogs';
import PracticePortal from 'components/practice';
import Calendar from 'components/practice/Calendar/Calendar';
import Dashboard from 'components/practice/Dashboard/Dashboard';
import PracticeDocuments from 'components/practice/Documents/PracticeDocuments';
import PracticeIQueue from 'components/practice/PracticeIQueue';
import AppointmentsQueue from 'components/practice/PracticeIQueue/Appointments/AppointmentsQueue';
import ClinicalNotes from 'components/practice/PracticeIQueue/ClinicalNotes/ClinicalNotes';
import FormPacket from 'components/practice/PracticeIQueue/FormPacket/FormPacket';
import Notifications from 'components/practice/PracticeIQueue/Notifications/Notifications';
import Orders from 'components/practice/PracticeIQueue/Orders/Orders';
import Overview from 'components/practice/PracticeIQueue/Overview/Overview';
import Tasks from 'components/practice/PracticeIQueue/Tasks/Tasks';
import ViewTask from 'components/practice/PracticeIQueue/Tasks/components/ViewTask';
import TreatmentPlanIQueue from 'components/practice/PracticeIQueue/TreatmentPlan';
import ProfileContainer from 'components/practice/Profile/ProfileContainer';

import {
  PRACTICE_BEYOND_BILLING,
  PRACTICE_CHARTS,
  PRACTICE_COMMS_CENTER,
  PRACTICE_SETTINGS
} from './index';

const PRACTICE_DASHBOARD = [
  {
    path: '',
    element: <PrivateRoutes type="portal" />,
    children: [
      {
        path: 'portal',
        element: <PracticePortal />,
        children: [
          {
            path: '',
            element: <Dashboard />
          },
          ...PRACTICE_CHARTS,
          ...PRACTICE_BEYOND_BILLING,
          ...PRACTICE_COMMS_CENTER,
          ...PRACTICE_SETTINGS,
          {
            path: 'audit',
            children: [{ path: 'logs', element: <AuditLogs /> }]
          },
          {
            path: 'profile',
            element: <ProfileContainer />
          },
          {
            path: 'appointments',
            element: <Calendar />,
            children: [
              {
                path: '*',
                element: <NotFound />
              }
            ]
          },
          {
            path: 'documents',
            element: <PracticeDocuments />
          },
          {
            path: 'practice-i-queue',
            element: <PracticeIQueue />,
            children: [
              {
                path: 'overview',
                element: <Overview />
              },
              {
                path: 'tasks',
                element: <Tasks />,
                children: [
                  {
                    path: ':id',
                    element: <ViewTask />
                  },
                  {
                    path: '*',
                    element: <NotFound />
                  }
                ]
              },
              {
                path: 'clinical-notes',
                element: <ClinicalNotes />
              },
              {
                path: 'treatment-plans',
                element: <TreatmentPlanIQueue />
              },
              {
                path: 'notifications',
                element: <Notifications />
              },
              {
                path: 'appointments',
                element: <AppointmentsQueue />
              },
              {
                path: 'forms',
                element: <FormPacket />
              },
              {
                path: 'orders',
                element: <Orders fromPatient={false} />
              }
            ]
          },
          {
            path: '*',
            element: <NotFound portal="portal" />
          }
        ]
      }
    ]
  }
];

export default PRACTICE_DASHBOARD;
